"use client";

export default function LeagueFilterV20QuickChips({
  chipStripClassName,
  quickLeagueChips,
  selectedIds,
  onQuickChipClick,
}) {
  return (
    <div className={`${chipStripClassName} mb-3`}>
      {quickLeagueChips.map((league) => {
        const label = league.nameVN || league.name || String(league.id);
        const active =
          selectedIds.length === 1 &&
          String(selectedIds[0]) === String(league.id);
        return (
          <button
            key={league.id}
            type="button"
            title={label}
            onClick={() => onQuickChipClick(league.id)}
            className={`shrink-0 cursor-pointer select-none rounded-[2px] border-0 px-2 py-1 text-sm font-medium whitespace-nowrap outline-none focus-visible:ring-2 focus-visible:ring-[var(--theme-filter-active-bg,#ffeb39)] ${
              active
                ? "bg-[var(--theme-filter-active-bg,#ffeb39)] text-[var(--theme-primary)]"
                : "bg-transparent text-white"
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
